
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import SummaryInprogressimg from "../Assets/images/SummaryInprogress.jpg";

const SummaryInprogress = ({ AISelectedApp }) => {

    return (
        <div className="container mt-2">
            <Tooltip id="ai-summary-tooltip" className="tooltip-custom align-items-center" />
            <h3 className=" d-flex justify-content-between align-items-center w-100" data-tooltip-id="ai-summary-tooltip"
                data-tooltip-content={'AttestaAI Report'}>
                <div className="analysis-row" >
                    <div className="d-flex align-items-center">
                        <div className="custom-icon-wrapper">
                            <span
                                className="custom-icon attesta-blue"
                                dangerouslySetInnerHTML={{
                                    __html: AISelectedApp?.summaryPmtIcon || AISelectedApp?.appIcon || '<i class="fa-solid fa-brain custom-icon"></i>',
                                }}
                            ></span>
                        </div>
                        <span className="ms-2 attesta-blue">{AISelectedApp?.summaryPmtLabel || AISelectedApp?.appName || "AttestaAI Summary"}</span>
                    </div>
                </div>
            </h3>

            <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
                <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
                    <div className="confirm-mgs-wrapper text-center">
                        <img src={SummaryInprogressimg} alt="review" className="reject-img" style={{ width: '400px' }} />

                        <p className='mt-4'>
                            {AISelectedApp?.summaryPmtLabel || AISelectedApp?.appName || "AttestaAI Summary"} {AISelectedApp?.summaryPmtLabel ? "agent" : ""}  is currently being processed.
                            This may take a few moments.<br /> Please wait while we complete the analysis.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SummaryInprogress;
